import React from "react"

import Banner from "@components/Banner"
import About from "@components/About"
import Cases from "@components/Cases"
import Contact from "@components/Contact"
import Footer from "@components/Footer"

const Home = () => {
  return (
    <>
      <Banner />
      <About />
      <Cases />
      <Contact />
      <Footer />
    </>
  )
}

export default Home
